import {
  AutoFixHigh as AutoFixHighIcon,
  MenuBook as MenuBookIcon,
  Science as ScienceIcon,
} from "@mui/icons-material";
import { Box, FormControlLabel, Link, Stack, Switch } from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
import { DOCS } from "../../../utils/constants";
import {
  isOrgActive,
  isOrgUser,
  isSandbox,
  setSandbox,
} from "../../../utils/io";
import theme from "../../../utils/theme";
import DocsTooltip from "../../DocsTooltip";
import NavLink from "./NavLink";

export default function NavSectionThree() {
  const sandboxFlag = isSandbox();
  const switchSandbox = (isOn) => {
    setSandbox(isOn);
    window.location.reload();
  };

  return (
    <Stack>
      <Link
        href="https://stel.wiki"
        target="_blank"
        rel="noreferrer"
        sx={{
          padding: "12.4px 12px",
          margin: "0 8px",
          borderRadius: "4px",
          color: theme.colors.darkGrey,
          textDecoration: "none",
          cursor: "pointer",
          "&:hover": {
            background: theme.colors.lighterBlue,
            color: theme.colors.blue,
            "& > svg": {
              color: theme.colors.blue,
            },
          },
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <MenuBookIcon
          sx={{
            mr: "8px",
            fontSize: theme.fontSize.large,
            marginLeft: "2.5px",
          }}
        />
        <Box
          component="span"
          sx={{
            fontSize: theme.fontSize.medium,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            height: 16.01,
          }}
        >
          Documentation
        </Box>
      </Link>

      {isOrgUser() && (
        <Box
          sx={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            cursor: "pointer",
            "&:hover": {
              background: theme.colors.lighterBlue,
              color: theme.colors.blue,
              "& > svg": {
                color: theme.colors.blue,
              },
            },
            display: "flex",
            justifyContent: "flex-start",
            padding: "10px 12px",
            margin: "0 8px",
            borderRadius: "4px",
            color: theme.colors.darkGrey,
            textDecoration: "none",
            "& .MuiFormControlLabel-root": {
              margin: 0,
            },
            "& .MuiTypography-root": {
              fontSize: theme.fontSize.medium,
            },
            ...(isOrgActive()
              ? {
                  cursor: "pointer",
                  "&:hover": {
                    background: theme.colors.lightBlue,
                    color: theme.colors.darkBlue,
                    "& > svg": {
                      color: theme.colors.darkBlue,
                    },
                  },
                }
              : { cursor: "no-drop", background: grey[100] }),
          }}
        >
          <ScienceIcon
            sx={{
              mr: "8px",
              fontSize: theme.fontSize.large,
              marginLeft: "2.5px",
            }}
          />
          <DocsTooltip
            description={DOCS.SANDBOX_MODE.description}
            docsUrl={DOCS.SANDBOX_MODE.url}
            placement="right"
          >
            <FormControlLabel
              labelPlacement="start"
              checked={sandboxFlag}
              onChange={(e) => switchSandbox(e.target.checked)}
              control={<Switch color="primary" size="small" />}
              label="Sandbox Mode"
              disabled={!isOrgActive()}
              sx={{
                fontSize: theme.fontSize.medium,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                height: 16.01,
              }}
            />
          </DocsTooltip>
        </Box>
      )}

      {isSandbox() && isOrgUser() && (
        <NavLink
          icon={AutoFixHighIcon}
          title="Simulator"
          path="/simulate-measurements"
        />
      )}
    </Stack>
  );
}
